import glamorous from 'glamorous'
import { Link } from 'react-router-dom'

import * as colours from '../../../../../styles/colours'

export const StyledLink = glamorous(Link)({
  color: colours.white,
  textDecoration: 'none',
})



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Login/components/Link/Link.glamorous.tsx